import React from 'react';

export const Space = props => {
  const { divider } = props?.settings;
  return <div className="cms-space w-full">{divider && <hr className="w-[unset]" />}</div>;
};
